import React from "react";
import ReactGA from "react-ga";

const tracking_code = "AA-12345678-90";

ReactGA.initialize(tracking_code);

type Props = {
  location?: {
    pathname: string;
  };
};

const withTracker = (WrappedComponent: any, options = {}) => {
  const trackPage = (page: any) => {
    ReactGA.set({
      page,
      ...options,
    });
    ReactGA.pageview(page);
  };

  const HOC = class extends React.Component<Props> {
    componentDidMount() {
      const page = this.props.location!.pathname;
      trackPage(page);
    }

    // componentWillReceiveProps(nextProps: any) {
    //   const currentPage = this.props.location!.pathname;
    //   const nextPage = nextProps.location.pathname;

    //   if (currentPage !== nextPage) {
    //     trackPage(nextPage);
    //   }
    // }

    render() {
      return <WrappedComponent {...this.props} />;
    }
  };

  return HOC;
};

export default withTracker;
